import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";

// import LazyVideo from "./lazy-video";
import LazyVideo from './MyLazyVideo';

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import ref_apple from './images/apple/ref.jpg'
import apple_diet from './images/apple/dietnerf.mp4'
import apple_ds from './images/apple/dsnerf.mp4'
import apple_sin from './images/apple/sinnerf.mp4'
import apple_ours from './images/apple/ours.mp4'
import ref_baseball from './images/baseball/ref.jpg'
import baseball_diet from './images/baseball/dietnerf.mp4'
import baseball_ds from './images/baseball/dsnerf.mp4'
import baseball_sin from './images/baseball/sinnerf.mp4'
import baseball_ours from './images/baseball/ours.mp4'
import ref_bench from './images/bench/ref.jpg'
import bench_diet from './images/bench/dietnerf.mp4'
import bench_ds from './images/bench/dsnerf.mp4'
import bench_sin from './images/bench/sinnerf.mp4'
import bench_ours from './images/bench/ours.mp4'
import ref_hydrant from './images/hydrant/ref.jpg'
import hydrant_diet from './images/hydrant/dietnerf.mp4'
import hydrant_ds from './images/hydrant/dsnerf.mp4'
import hydrant_sin from './images/hydrant/sinnerf.mp4'
import hydrant_ours from './images/hydrant/ours.mp4'
import ref_suitcase from './images/suitcase/ref.jpg'
import suitcase_diet from './images/suitcase/dietnerf.mp4'
import suitcase_ds from './images/suitcase/dsnerf.mp4'
import suitcase_sin from './images/suitcase/sinnerf.mp4'
import suitcase_ours from './images/suitcase/ours.mp4'
import ref_remote from './images/remote/ref.jpg'
import remote_diet from './images/remote/dietnerf.mp4'
import remote_ds from './images/remote/dsnerf.mp4'
import remote_sin from './images/remote/sinnerf.mp4'
import remote_ours from './images/remote/ours.mp4'
import ref_sandwich from './images/sandwich/ref.jpg'
import sandwich_diet from './images/sandwich/dietnerf.mp4'
import sandwich_ds from './images/sandwich/dsnerf.mp4'
import sandwich_sin from './images/sandwich/sinnerf.mp4'
import sandwich_ours from './images/sandwich/ours.mp4'
import ref_cabin2 from './images/cabin2/ref.jpeg'
import cabin2_diet from './images/cabin2/dietnerf.mp4'
import cabin2_ds from './images/cabin2/dsnerf.mp4'
import cabin2_sin from './images/cabin2/sinnerf.mp4'
import cabin2_ours from './images/cabin2/ours.mp4'
import ref_cabin4 from './images/cabin4/ref.jpeg'
import cabin4_diet from './images/cabin4/dietnerf.mp4'
import cabin4_ds from './images/cabin4/dsnerf.mp4'
import cabin4_sin from './images/cabin4/sinnerf.mp4'
import cabin4_ours from './images/cabin4/ours.mp4'
import ref_liberty from './images/liberty/ref.jpg'
import liberty_diet from './images/liberty/dietnerf.mp4'
import liberty_ds from './images/liberty/dsnerf.mp4'
import liberty_sin from './images/liberty/sinnerf.mp4'
import liberty_ours from './images/liberty/ours.mp4'


const OurVideo = ({src}) => (
  (
   <video
         src={src}
         width="100%"
         loop="loop"
         autoplay=""
         muted
         playsInline
         webkit-playsinline
       ></video>
 )
 );

const myVideo = () => (
  <div>
    <Header as="h2" textAlign="center" style={subsection_style}>
      Comparisons
    </Header>
    <p>
      We compare our method with the state-of-the-art neural radiance field
      methods DietNeRF, DS-NeRF and SinNeRF. Since DS-NeRF and SinNeRF rely on the exact value of the available depth information, their performance using monocular depth estimation is far from satisfactory. It can also be seen that the DietNeRF suffers from unconstrained geometry. Our method, on the other hand, is able to synthesize visually pleasing novel views with 3D consistency.
    </p>
    <Grid columns={5}>
      <Grid.Row textAlign="center" style={{ fontSize: "1em" }}>
        <Grid.Column>Reference</Grid.Column>
        <Grid.Column>DS-NeRF</Grid.Column>
        <Grid.Column>DietNeRF</Grid.Column>
        <Grid.Column>SinNeRF</Grid.Column>
        <Grid.Column>
          <b>NeuralLift-360</b>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_apple}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={apple_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={apple_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={apple_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={apple_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_baseball}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={baseball_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={baseball_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={baseball_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={baseball_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_bench}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={bench_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={bench_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={bench_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={bench_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_hydrant}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={hydrant_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={hydrant_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={hydrant_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={hydrant_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_suitcase}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={suitcase_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={suitcase_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={suitcase_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={suitcase_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_remote}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={remote_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={remote_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={remote_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={remote_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_sandwich}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={sandwich_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={sandwich_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={sandwich_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={sandwich_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_cabin2}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin2_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin2_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin2_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin2_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_cabin4}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin4_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin4_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin4_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={cabin4_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Image src={ref_liberty}></Image>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={liberty_ds}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={liberty_diet}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={liberty_sin}></LazyVideo>
        </Grid.Column>
        <Grid.Column>
          <LazyVideo src={liberty_ours}></LazyVideo>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

export default myVideo;
